
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }
  if(Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && window.flitsObjects.storeData.customer_id != -1){
    Flits.LoadStyleScript('cartJs',window.flitsObjects.allCssJs.cartJs.url);
  }
  Flits(document).on('Flits:AccountPage:Loaded', function(event){  
    var data = event.detail;
    data.settings.active_tab = '#order';
  });
  Flits(document).on('Flits:myProfile:Loaded', function(event){
  	let customer_detail_url = Flits.base_url + "/" + Flits.customer_id + "/profile_save";
    Flits.ajax({
      method: "get",
      url: customer_detail_url,
      data: {
        customer_hash: Flits.customerHash, token:Flits.token
      },
    }).done(function(resp){
      if(resp.customer.accepts_marketing == 1){
        Flits('#accepts_marketing').prop('checked', true);
        window.accept_marketing_flits = true;
      }
      else{
      	window.accept_marketing_flits = false;
      }
    });
  });
  Flits(document).on('Flits:myProfile:BeforeUpdate', function(event){
    var e_data =  event.detail.params;
    var acceptsMarketing;
    if (Flits('input#accepts_marketing').is(':checked')) {
      acceptsMarketing = 1;
    }
    else{
      acceptsMarketing = 0;
    }
    e_data.push({"name":"accepts_marketing","value":acceptsMarketing});
  });
  Flits(document).on('Flits:myProfile:Updated', function(event){
    if(event.detail.resp.customer.accepts_marketing == true){
      window.accept_marketing_flits = true;
    }
    else{
      window.accept_marketing_flits = false;
    }
  });
  Flits(document).on("click", ".flits-profile-cancel-button", function () {
    setTimeout(function(){
      if(window.accept_marketing_flits == true){
        Flits('#accepts_marketing').prop('checked', true);
      }
      if( !Flits('#flits-profile-gender').val() ) {
      	Flits('#flits-profile-gender').val('none');
      }
    }, 1000);
  });
}(Flits));
